import { Badge } from '@/components/ui/badge'
import { formatKES } from '@/lib/utils'
import type { Invoice, InvoiceStatus } from '@riverpark/types'

export function StatusBadge({ status }: { status: InvoiceStatus }) {
  switch (status) {
    case 'paid':
      return <Badge variant="paid">Paid</Badge>
    case 'overdue':
      return <Badge variant="overdue">Overdue</Badge>
    case 'sent':
      return <Badge variant="pending">Sent</Badge>
    case 'voided':
      return <Badge variant="default">Voided</Badge>
    default:
      return <Badge variant="draft">Draft</Badge>
  }
}

/** Credit notes have their own tab, so this only ever needs to flag supplementary invoices. */
export function InvoiceTypeBadge({ invoiceType }: { invoiceType: Invoice['invoiceType'] }) {
  if (invoiceType === 'supplementary') return <Badge variant="overdue">Supplementary</Badge>
  return null
}

export function formatDate(unixSeconds?: number) {
  if (!unixSeconds) return '—'
  return new Date(unixSeconds * 1000).toLocaleDateString('en-KE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

/** No stored 'partial' status — show the real balance whenever something's been paid but not all of
 * it. Only for standard invoices — a credit note being "consumed" isn't a due/of split worth showing. */
export function AmountCell({ invoice }: { invoice: Invoice }) {
  const isPartial =
    invoice.invoiceType === 'standard' &&
    invoice.amountPaid > 0 &&
    invoice.status !== 'paid' &&
    invoice.status !== 'voided'
  if (!isPartial) return <>{formatKES(invoice.amount)}</>
  return (
    <span>
      {formatKES(invoice.balance)} due{' '}
      <span className="text-xs text-muted-foreground">of {formatKES(invoice.amount)}</span>
    </span>
  )
}
